<div class="edit-page-root-container usergroup-edit-root-container">
  <div class="page-content">
    <div class="page-header">
      <button mat-button class="nav-button" (click)="navBack()">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <div class="title">
        {{title}}
      </div>
      <div class="action-btn-container">
        @if(permission.can_edit){
        <button mat-flat-button class="action-btn btn-discard" (click)="navBack()">DISCARD</button>
        <button mat-flat-button class="action-btn btn-save" (click)="save()">SAVE</button>
        }
      </div>
    </div>
    <div class="page-details">
      <form class="edit-form" [formGroup]="editForm">
        <div class="detail-section">
          <div class="content-container">

            <mat-tab-group animationDuration="0ms" style="width:100%;">
              <mat-tab label="General">

                <div class="input-group" style="margin-top: 20px;">
                  <div class="input-box-left">
                    <mat-form-field class="code">
                      <mat-label>Code</mat-label>
                      <input matInput formControlName="code" maxlength="50" appCodeInput
                        [readonly]="userInfo.id!==undefined && userInfo.id!==0">
                      <mat-error *ngIf="editForm.controls['code'].hasError('required')">Code should be
                        entered</mat-error>
                      <mat-error *ngIf="editForm.controls['code'].hasError('maxlength')">Maximum length is
                        10.</mat-error>
                    </mat-form-field>
                  </div>

                  <div class="input-box-right"> <mat-form-field class="name">
                      <mat-label>Name</mat-label>
                      <input matInput formControlName="name">
                      <mat-error *ngIf="editForm.controls['name'].hasError('required')">Name should be
                        entered</mat-error>
                      <mat-error *ngIf="editForm.controls['name'].hasError('maxlength')">Maximum length is
                        50.</mat-error>
                    </mat-form-field></div>
                </div>
                <div class="input-group">
                  <div class="input-box-right">
                    <mat-form-field class="name" style="width: 100%;">
                      <mat-label>User Group</mat-label>
                      <input type="text" aria-label="User Group" matInput formControlName="user_group_id"
                        [matAutocomplete]="autoGroup" [readonly]="isEditMode">
                      <button matSuffix mat-icon-button aria-label="Clear" (click)="clearUserGroup()"
                        *ngIf="editForm.get('user_group_id')?.value && !isEditMode">
                        <mat-icon>close</mat-icon>
                      </button>
                      <mat-autocomplete #autoGroup="matAutocomplete" autoActiveFirstOption
                        [displayWith]="displayUserGroup" (optionSelected)="onUserGroupSelected($event)">
                        @for (group of (filteredUserGroups | async); track group.id)
                        {
                        <mat-option [value]="group.id">{{group.name}}</mat-option>
                        }
                      </mat-autocomplete>
                      <mat-error *ngIf="editForm.controls['user_group_id']?.hasError('required')">User Group is
                        required</mat-error>
                    </mat-form-field>
                  </div>

                  <div class="input-box-right">                    <mat-form-field class="name" style="width: 100%;">
                      <mat-label>Employee</mat-label>
                      <input type="text" aria-label="Employee" matInput formControlName="employee_id"
                        [matAutocomplete]="autoEmp" [readonly]="isEditMode">
                      <button matSuffix mat-icon-button aria-label="Clear" (click)="clearEmployee()"
                        *ngIf="editForm.get('employee_id')?.value && !isEditMode">
                        <mat-icon>close</mat-icon>
                      </button>
                      <mat-autocomplete #autoEmp="matAutocomplete" autoActiveFirstOption
                        [displayWith]="displayEmployee" (optionSelected)="onEmployeeSelected($event)">
                        @for (emp of (filteredEmployees | async); track emp.id)
                        {
                        <mat-option [value]="emp.id">{{displayEmployee(emp.id)}}</mat-option>
                        }
                      </mat-autocomplete>
                    </mat-form-field>
</div>
                </div>
                <div class="input-group">
                  <div class="input-box-right"> <!-- Card No -->
                    <mat-form-field class="name">
                      <mat-label>Card No</mat-label>
                      <input matInput formControlName="card_no">
                      <mat-error *ngIf="editForm.controls['card_no']?.hasError('required')">Card No should be
                        entered</mat-error>
                    </mat-form-field>
                  </div>


                  <div class="input-box-right"> <!-- Card No -->

                    <!-- Email -->
                    <mat-form-field class="name">
                      <mat-label>Email</mat-label>
                      <input matInput formControlName="email" autocomplete="email-no-fill">
                      <mat-error *ngIf="editForm.controls['email']?.hasError('email')">Invalid email address</mat-error>
                    </mat-form-field>
                  </div>
                </div>


                <div class="input-group">
                  <div class="input-box-right"> <!-- Card No -->

                    <!-- Valid From -->
                    <mat-form-field class="name">
                      <mat-label>Valid From</mat-label>
                      <input matInput [matDatepicker]="validFromPicker" formControlName="valid_from">
                      <mat-datepicker-toggle matSuffix [for]="validFromPicker"></mat-datepicker-toggle>
                      <mat-datepicker #validFromPicker></mat-datepicker>
                      <mat-error *ngIf="editForm.get('valid_from')?.hasError('dateRange')">From date should be before To
                        date</mat-error>
                    </mat-form-field>
                  </div>
                  <div class="input-box-right"> <!-- Card No -->

                    <!-- Valid From -->
                    <!-- Valid To -->
                    <mat-form-field class="name">
                      <mat-label>Valid To</mat-label>
                      <input matInput [matDatepicker]="validToPicker" formControlName="valid_to">
                      <mat-datepicker-toggle matSuffix [for]="validToPicker"></mat-datepicker-toggle>
                      <mat-datepicker #validToPicker></mat-datepicker>
                      <mat-error *ngIf="editForm.get('valid_to')?.hasError('dateRange')">To date should be after From
                        date</mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="input-group" *ngIf="!isEditMode">
                  <div class="input-box-right">
                    <mat-form-field class="password">
                      <mat-label>Password</mat-label>
                      <input matInput type="password" formControlName="password" autocomplete="new-password">
                      <mat-error *ngIf="editForm.get('password')?.hasError('required')">Password is required</mat-error>
                    </mat-form-field>
                  </div>
                  <div class="input-box-right">
                    <mat-form-field class="confirm-password">
                      <mat-label>Confirm Password</mat-label>
                      <input matInput type="password" formControlName="confirm_password" autocomplete="new-password">
                      <mat-error *ngIf="editForm.get('confirm_password')?.hasError('required')">Confirmation is
                        required</mat-error>
                      <mat-error *ngIf="editForm.get('confirm_password')?.hasError('passwordMismatch')">Passwords do not
                        match</mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <div class="input-group">
                  <div class="input-box-left">
                    <button *ngIf="isEditMode" mat-raised-button type="button" (click)="openChangePasswordDialog()"
                      style="margin-bottom: 20px;">Change Password</button>
                  </div>
                  <div class="input-box-right">
                    <mat-checkbox formControlName="is_active">Active</mat-checkbox>
                  </div>
                </div>


              </mat-tab>

              <mat-tab label="Shops" *ngIf="isShopUser">
                <div class="detail-section">
                  <div class="content-container">

                    <div style="display: flex; align-items: center; gap: 16px; margin-bottom: 16px;">
                      <!-- Area (city) dropdown filter -->
                      <mat-form-field appearance="fill" style="width: 300px;">
                        <mat-label>Area</mat-label>
                        <mat-select [multiple]="true" [(value)]="selectedAreas"
                          (selectionChange)="onAreaSelectionChange($event.value)" [placeholder]="'All Areas'">
                          <mat-select-trigger>
                            {{selectedAreas.length === areaList.length ? 'All Areas' : selectedAreas.join(', ')}}
                          </mat-select-trigger>
                          <mat-option *ngFor="let area of areaList" [value]="area">{{ area }}</mat-option>
                        </mat-select>
                        <button *ngIf="selectedAreas.length" mat-icon-button matSuffix aria-label="Clear"
                          (click)="onAreaSelectionChange([]); $event.stopPropagation();">
                          <mat-icon>clear</mat-icon>
                        </button>
                      </mat-form-field>
                      <!-- Shop search filter -->
                      <!-- <mat-form-field appearance="outline" style="flex: 1; max-width: 350px;">
          <mat-icon matPrefix>search</mat-icon>
          <input
            matInput
            type="text"
            placeholder="Search"
            [(ngModel)]="shopSearch"
            [ngModelOptions]="{standalone: true}"
            (ngModelChange)="onShopSearchChange($event)"
            autocomplete="off"
            />
        </mat-form-field> -->
                      <div class="search-input-container" style="margin-top: -15px;">
                        <div class="free-search">
                          <button mat-button class="search-icon">
                            <mat-icon>search</mat-icon>
                          </button>

                          <div class="search-input">
                            <input matInput placeholder="Search..." [(ngModel)]="shopSearch"
                              [ngModelOptions]="{ standalone: true }" (ngModelChange)="onShopSearchChange($event)"
                              autocomplete="off" />
                          </div>


                        </div>
                      </div>

                    </div>

                    <table class="table table-bordered" style="width:100%;">
                      <thead>
                        <tr>
                          <th>SL</th>
                          <th style="text-align: left;">CODE</th>
                          <th style="text-align: left;">NAME</th>
                          <th style="text-align: left;">Area</th>
                          <th style="text-align: left;">
                            <mat-checkbox [checked]="isAllShopsChecked()"
                              [indeterminate]="isSomeShopsChecked() && !isAllShopsChecked()"
                              (change)="onSelectAllShops($event.checked)">
                            </mat-checkbox>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let shop of sortedShopUserMapping; let i = index; trackBy: trackByShop">
                          <td style="text-align: center;">{{ i+1 }}</td>
                          <td style="text-align: left;">{{ shop.code }}</td>
                          <td style="text-align: left;">{{ shop.name }}</td>
                          <td style="text-align: left;">{{ shop.area || 'No Area' }}</td>
                          <td style="text-align: left;">
                            <mat-checkbox [checked]="isShopChecked(shop)"
                              (change)="onShopCheckboxChange(shop, $event.checked)">
                            </mat-checkbox>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <ng-template #noShops>
                  <div>No shops mapped to this user.</div>
                </ng-template>
              </mat-tab>


            </mat-tab-group>













          </div>
        </div>
      </form>
    </div>
  </div>
</div>